/**
 * Created by Akhtar on 22/10/2019.
 */

import React from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import * as PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import {PostRequest} from "../../../common/requests";
import {URL} from "../../../common/url";
import { withTranslation } from 'react-i18next';


const styles = {
  modal: {
    background: 'white',
    position: 'relative',
    width: '450px',
    top: '20%',
    left: '35%',
    textAlign: 'left',
  },
  modalTitle: {
    background: 'linear-gradient(70deg, #5159F8, #5EAAFF)',
    color: 'white',
    textAlign: 'left',
    padding: '15px',
  },
  modalContent: {
    padding: '20px',
  },
  formInput: {
    margin: '10px',
    width: '95%'
  },
  submit: {
    textAlign: 'right',
    borderTop: '1px solid #E1E3E4',
    paddingTop: '24px'
  },
  actionButton: {
    marginRight: '10px',
    color: '#d3d3d3',
    fontSize: '16px',
    fontWeight: 'bold'
  },
  descriptionText: {
    margin: '40px auto 4px 10px',
    width: '95%',
    color: '#1e2a5a',
    fontSize: '17px',
    fontFamily: '\'Open Sans\', sans-serif !important'
  }
};

const validateEmail = function(email) {
  let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}


class CreateSuperAdmin extends React.Component{
  static propTypes = {
    modalOpen: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
  };

  state = {
    name: '',
    email: '',
    submit: false,
    nameError: '',
    emailError: ''
  };

  controller = new window.AbortController();

  checkValidations() {
    const {t} = this.props;
    if (!this.state.submit) {
      return;
    }
    let valid = true;
    let nameError = "";
    let emailError = "";

    if (!this.state.name || this.state.name.trim() === '') {
      nameError = t('msg.name-empty');
      valid = false;
    }

    if (this.state.email) {
      if (!validateEmail(this.state.email)) {
        emailError = t('msg.invalid-email');
        valid = false;
      }
    } else {
      emailError = t('msg.empty-email');
      valid = false;
    }

    this.setState({
      nameError: nameError,
      emailError: emailError
    });
    return valid;
  }


  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(prevState => ({ ...prevState, [name]: value }), () => this.checkValidations());
  };

  handleAdd = () => {
    const { name , email} = this.state;
    const { modalOpen} = this.props;
    const payload = {
      name: name,
      email: email,
      is_superuser: true,
      is_admin: false
    };
    this.setState({submit: true}, ()=> {
      if (this.checkValidations()) {
        PostRequest(URL.users, this.controller.signal, payload, (data) => {
          modalOpen(false);
          this.props.handleUserAdded();
        }, (err) => {
          console.log(err)
        });
      }})
  };

  render() {
    const {t, classes, modalOpen} = this.props;
    const {name, email, nameError, emailError} = this.state;
    return(
      <div className={classes.modal} key="inputForm">
        <div className={classes.modalTitle}>
          <Typography variant="h6" >
            {t('super-admin.txt2')}
          </Typography>
        </div>
        <div className={classes.modalContent}>
          <Typography variant="subtitle1" style={{marginBottom:'8px'}}>
            <b>{t('super-admin.inv-sup-user')}</b>
          </Typography>
          <Typography variant="subtitle1" style={{marginBottom:'8px'}}>
          {t('super-admin.invite-txt')}
          </Typography>
          <form onSubmit={event => {event.preventDefault();}} noValidate>
            <TextField
              name="name"
              id="name"
              label={t('super-admin.txt2')}
              onChange={this.handleChange}
              value={name}
              className={classes.formInput}
              inputProps={{ maxLength: 64 }}
              helperText={nameError}
              error={nameError !== ''}
            />
            {/*<div className={classes.descriptionText}>Description</div>*/}
            <TextField
              inputProps={{ maxLength: 64 }}
              helperText={emailError}
              name="email"
              label={t('super-admin.prim-mail')}
              id="email"
              onChange={this.handleChange}
              value={email}
              className={classes.formInput}
              style={{marginBottom: '38px'}}
              error={emailError !== ''}
            />
            <div className={classes.submit}>
              <Button className={classes.actionButton} onClick={() => modalOpen(false)}>{t('super-admin.cancel')}</Button>
              <Button onClick={this.handleAdd} className="successButton">{t('super-admin.add-new-admin')}</Button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default withTranslation()(withStyles(styles)(CreateSuperAdmin));
